<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows" v-if="!editMode">
          <v-card color="grey lighten-4" class="pl-3 pr-3 pb-1 elevation-1">
            <v-card-text>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md4>
                  <h3 class="mb-1">Zůstatek:</h3> <strong>25 000 KČ | 100 EUR | 105 USD</strong>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <!-- Autocomplete -->
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-btn color="primary" class="right elevation-0"><v-icon small class="mr-2">attach_file</v-icon> Otevřené položky</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card color="grey lighten-4" class="mt-3 pt-3 pl-3 pr-3 pb-1 elevation-1">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3 class="body-3 mb-0 bold">Pohyby</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <div class="table-border__radius elevation-1">
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      hide-controls
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.datum }}</td>
                        <td>{{ props.item.castka }}</td>
                        <td>{{ props.item.vs }}</td>
                        <td>{{ props.item.popis }}</td>
                        <td>{{ props.item.stav }}</td>
                        <td class="text-center">
                          <router-link :to="{ path: '/' }"><v-btn color="primary" class="elevation-0"><v-icon small class="mr-2">cloud_download</v-icon> Faktura</v-btn></router-link>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card color="grey lighten-4" class="mt-3 pt-3 pl-3 pr-3 pb-1 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3 class="body-3 mb-0 bold">Objednávky</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <div class="table-border__radius elevation-1">
                    <v-data-table
                      :headers="headers2"
                      :items="items"
                      hide-controls
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.datum }}</td>
                        <td>{{ props.item.castka }}</td>
                        <td>{{ props.item.vs }}</td>
                        <td>{{ props.item.popis }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card-actions class="mt-4">
            <v-btn color="primary" v-if="!editMode" @click="editModeClick" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
          </v-card-actions>
        </div>

        <div class="gui-flex gui-flex-rows" v-else>
          <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2 class="body-3 mb-0 bold">Detail obchodu</h2>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Datum" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field label="Klient" class="mx-2"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card-actions class="mt-4">
            <v-btn color="primary" @click="edit" class="elevation-0"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      activeTab: 0,
      tabs: [ 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'VS', value: 'vs' },
        { text: 'Popis', value: 'popis' },
        { text: 'Stav', value: 'stav' },
        { text: 'Doklad', value: 'doklad', sortable: false, align: "center" }
      ],
      headers2: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'VS', value: 'vs' },
        { text: 'Popis', value: 'popis' }
      ],
      items: [
        {
          datum: '2. 1. 2019',
          castka: '20 000 Kč',
          vs: '7776665551',
          popis: 'Lorem ipsum',
          stav: 'Spárováno'
        }
      ]
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  methods: {
    editModeClick () {
      this.editMode = true
    },
    edit () {
      this.editMode = false
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/ElektronickaPenezenkaDetail.vue